module.exports = __webpack_public_path__ + "static/img/yuanjing.d7493d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobiigw/yuanjing.png
// module id = kizC
// module chunks = 1